/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { ExpectedPartitionValueInformation } from '../model/expectedPartitionValueInformation';
import { ExpectedPartitionValuesCreateRequest } from '../model/expectedPartitionValuesCreateRequest';
import { ExpectedPartitionValuesDeleteRequest } from '../model/expectedPartitionValuesDeleteRequest';
import { ExpectedPartitionValuesInformation } from '../model/expectedPartitionValuesInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class ExpectedPartitionValueService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createExpectedPartitionValues
     * Creates a list of expected partition values for an existing partition key group.
     * @param expectedPartitionValuesCreateRequest the information needed to create the expected partition values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public expectedPartitionValueCreateExpectedPartitionValues(expectedPartitionValuesCreateRequest: ExpectedPartitionValuesCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<ExpectedPartitionValuesInformation>;
    public expectedPartitionValueCreateExpectedPartitionValues(expectedPartitionValuesCreateRequest: ExpectedPartitionValuesCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExpectedPartitionValuesInformation>>;
    public expectedPartitionValueCreateExpectedPartitionValues(expectedPartitionValuesCreateRequest: ExpectedPartitionValuesCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExpectedPartitionValuesInformation>>;
    public expectedPartitionValueCreateExpectedPartitionValues(expectedPartitionValuesCreateRequest: ExpectedPartitionValuesCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (expectedPartitionValuesCreateRequest === null || expectedPartitionValuesCreateRequest === undefined) {
            throw new Error('Required parameter expectedPartitionValuesCreateRequest was null or undefined when calling expectedPartitionValueCreateExpectedPartitionValues.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ExpectedPartitionValuesInformation>(`${this.configuration.basePath}/expectedPartitionValues`,
            expectedPartitionValuesCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteExpectedPartitionValues
     * Deletes specified expected partition values from an existing partition key group which is identified by name.
     * @param expectedPartitionValuesDeleteRequest the information needed to delete the expected partition values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public expectedPartitionValueDeleteExpectedPartitionValues(expectedPartitionValuesDeleteRequest: ExpectedPartitionValuesDeleteRequest, observe?: 'body', reportProgress?: boolean): Observable<ExpectedPartitionValuesInformation>;
    public expectedPartitionValueDeleteExpectedPartitionValues(expectedPartitionValuesDeleteRequest: ExpectedPartitionValuesDeleteRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExpectedPartitionValuesInformation>>;
    public expectedPartitionValueDeleteExpectedPartitionValues(expectedPartitionValuesDeleteRequest: ExpectedPartitionValuesDeleteRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExpectedPartitionValuesInformation>>;
    public expectedPartitionValueDeleteExpectedPartitionValues(expectedPartitionValuesDeleteRequest: ExpectedPartitionValuesDeleteRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (expectedPartitionValuesDeleteRequest === null || expectedPartitionValuesDeleteRequest === undefined) {
            throw new Error('Required parameter expectedPartitionValuesDeleteRequest was null or undefined when calling expectedPartitionValueDeleteExpectedPartitionValues.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<ExpectedPartitionValuesInformation>(`${this.configuration.basePath}/expectedPartitionValues`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getExpectedPartitionValue
     * Retrieves an existing expected partition value plus/minus an optional offset.
     * @param partitionKeyGroupName the partition key group name
     * @param expectedPartitionValue the expected partition value to retrieve plus/minus an optional offset
     * @param offset the optional positive or negative offset
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public expectedPartitionValueGetExpectedPartitionValue(partitionKeyGroupName: string, expectedPartitionValue: string, offset?: number, observe?: 'body', reportProgress?: boolean): Observable<ExpectedPartitionValueInformation>;
    public expectedPartitionValueGetExpectedPartitionValue(partitionKeyGroupName: string, expectedPartitionValue: string, offset?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExpectedPartitionValueInformation>>;
    public expectedPartitionValueGetExpectedPartitionValue(partitionKeyGroupName: string, expectedPartitionValue: string, offset?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExpectedPartitionValueInformation>>;
    public expectedPartitionValueGetExpectedPartitionValue(partitionKeyGroupName: string, expectedPartitionValue: string, offset?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (partitionKeyGroupName === null || partitionKeyGroupName === undefined) {
            throw new Error('Required parameter partitionKeyGroupName was null or undefined when calling expectedPartitionValueGetExpectedPartitionValue.');
        }
        if (expectedPartitionValue === null || expectedPartitionValue === undefined) {
            throw new Error('Required parameter expectedPartitionValue was null or undefined when calling expectedPartitionValueGetExpectedPartitionValue.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ExpectedPartitionValueInformation>(`${this.configuration.basePath}/expectedPartitionValues/partitionKeyGroups/${encodeURIComponent(String(partitionKeyGroupName))}/expectedPartitionValues/${encodeURIComponent(String(expectedPartitionValue))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getExpectedPartitionValues
     * Retrieves a range of existing expected partition values.
     * @param partitionKeyGroupName the partition key group name
     * @param startExpectedPartitionValue the start expected partition value for the expected partition value range
     * @param endExpectedPartitionValue the end expected partition value for the expected partition value range
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public expectedPartitionValueGetExpectedPartitionValues(partitionKeyGroupName: string, startExpectedPartitionValue?: string, endExpectedPartitionValue?: string, observe?: 'body', reportProgress?: boolean): Observable<ExpectedPartitionValuesInformation>;
    public expectedPartitionValueGetExpectedPartitionValues(partitionKeyGroupName: string, startExpectedPartitionValue?: string, endExpectedPartitionValue?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExpectedPartitionValuesInformation>>;
    public expectedPartitionValueGetExpectedPartitionValues(partitionKeyGroupName: string, startExpectedPartitionValue?: string, endExpectedPartitionValue?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExpectedPartitionValuesInformation>>;
    public expectedPartitionValueGetExpectedPartitionValues(partitionKeyGroupName: string, startExpectedPartitionValue?: string, endExpectedPartitionValue?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (partitionKeyGroupName === null || partitionKeyGroupName === undefined) {
            throw new Error('Required parameter partitionKeyGroupName was null or undefined when calling expectedPartitionValueGetExpectedPartitionValues.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startExpectedPartitionValue !== undefined && startExpectedPartitionValue !== null) {
            queryParameters = queryParameters.set('startExpectedPartitionValue', <any>startExpectedPartitionValue);
        }
        if (endExpectedPartitionValue !== undefined && endExpectedPartitionValue !== null) {
            queryParameters = queryParameters.set('endExpectedPartitionValue', <any>endExpectedPartitionValue);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ExpectedPartitionValuesInformation>(`${this.configuration.basePath}/expectedPartitionValues/partitionKeyGroups/${encodeURIComponent(String(partitionKeyGroupName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
